var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5092"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.1-851.936a2.063 2.063 0 0 1-1.516-.623 2.063 2.063 0 0 1-.623-1.516 2.063 2.063 0 0 1 .623-1.516 2.063 2.063 0 0 1 1.516-.623 2.063 2.063 0 0 1 1.516.623 2.063 2.063 0 0 1 .623 1.516 2.063 2.063 0 0 1-.623 1.516 2.063 2.063 0 0 1-1.516.623zm-3.422 5.045a1.618 1.618 0 0 1-1.189-.487 1.617 1.617 0 0 1-.487-1.189v-12.407a1.617 1.617 0 0 1 .487-1.189 1.617 1.617 0 0 1 1.189-.487h1.283v-1.961h1.426v1.961h7.023v-1.961h1.39v1.961h1.283a1.617 1.617 0 0 1 1.189.487 1.617 1.617 0 0 1 .487 1.189v12.407a1.617 1.617 0 0 1-.487 1.189 1.618 1.618 0 0 1-1.189.487zm0-1.39h12.407a.272.272 0 0 0 .2-.089.272.272 0 0 0 .089-.2v-8.7H141.39v8.7a.272.272 0 0 0 .089.2.272.272 0 0 0 .197.088zm-.285-10.375h12.977v-2.317a.272.272 0 0 0-.089-.2.272.272 0 0 0-.2-.089h-12.405a.272.272 0 0 0-.2.089.272.272 0 0 0-.089.2zm0 0z",
    transform: "translate(-137 866.61)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.e904adba9e9750ee2c570b24c2d4a84c.svg";
export { ForwardRef as ReactComponent };